import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { ChatComponent } from './chat';
import { ChatMessageComponent } from './chat-message';
import { AutoFocusDirective, HighlightDirective, ScrollBottomDirective } from './directives';
import { DynamicFormsComponent } from './dynamic-forms';
import { LoadingComponent } from './loading';
import { MatAlertComponent } from './mat-alert';
import { FilterPipe, treeFilterPipe, FromNowPipe} from './pipes';
import { QuickResponseComponent } from './quick-response';
import { ChatAIConnectService, MessageService, UserService } from './services';
import { TreeComponent } from './tree-component';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    ChatComponent,
    ChatMessageComponent,
    FromNowPipe,
    FilterPipe,
    treeFilterPipe,
    HighlightDirective,
    TreeComponent,
    ScrollBottomDirective,
    // SearchResultComponent,
    // FilterListPipe,
    QuickResponseComponent,
    // SearchContextComponent,
    AutoFocusDirective,
    LoadingComponent,
    DynamicFormsComponent,
    MatAlertComponent,
    // NgMaterialModule
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    // HttpModule,
    BrowserAnimationsModule,
    NgbModule,
    // AppRoutingModule,
    MatGridListModule,
    MatDialogModule,
    MatButtonModule
  ],
  providers: [
    MessageService,
    UserService,
    ChatAIConnectService,
    // UIConnectService
    // PaginationService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { constructor() {
  // Initialize Application Insights with your Instrumentation Key
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: '00ac7637-4947-43c4-b4bd-432cd54cc735',
    }
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView(); // Track page views
}}
